@if (dialogService.isOpen() && dialogService.options(); as options) {
  <yds-modal
    [open]="dialogService.isOpen()"
    [title]="options.titleKey ? (options.titleKey | translate) : (options.title ?? '')"
    [variant]="options.variant || 'warning'"
    size="sm"
    closeAriaLabelKey="App-Journaling.yds-modal.Close"
    (close)="onDismiss()"
  >
    <p class="confirm-dialog__message">
      {{ options.messageKey ? (options.messageKey | translate) : (options.message ?? '') }}
    </p>

    <div footer class="confirm-dialog__actions">
      @if (options.cancelTextKey || options.cancelText) {
        <yds-button [variant]="options.variant === 'error' ? 'default' : 'secondary'" (click)="cancel()">
          {{ options.cancelTextKey ? (options.cancelTextKey | translate) : (options.cancelText ?? '') }}
        </yds-button>
      }
      <yds-button [variant]="options.variant === 'error' ? 'destructive-primary' : 'primary'" (click)="confirm()">
        {{ options.confirmTextKey ? (options.confirmTextKey | translate) : (options.confirmText ?? '') }}
      </yds-button>
    </div>
  </yds-modal>
}
